"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSkuShopProductImageSkuVariationToJSON = exports.ProductSkuShopProductImageSkuVariationFromJSONTyped = exports.ProductSkuShopProductImageSkuVariationFromJSON = exports.instanceOfProductSkuShopProductImageSkuVariation = void 0;
var runtime_1 = require("../runtime");
var PriceInformation_1 = require("./PriceInformation");
var ProductImage_1 = require("./ProductImage");
var ProductSku_1 = require("./ProductSku");
var ShopProductImage_1 = require("./ShopProductImage");
var TagType_1 = require("./TagType");
/**
 * Check if a given object implements the ProductSkuShopProductImageSkuVariation interface.
 */
function instanceOfProductSkuShopProductImageSkuVariation(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductSkuShopProductImageSkuVariation = instanceOfProductSkuShopProductImageSkuVariation;
function ProductSkuShopProductImageSkuVariationFromJSON(json) {
    return ProductSkuShopProductImageSkuVariationFromJSONTyped(json, false);
}
exports.ProductSkuShopProductImageSkuVariationFromJSON = ProductSkuShopProductImageSkuVariationFromJSON;
function ProductSkuShopProductImageSkuVariationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'color': !(0, runtime_1.exists)(json, 'color') ? undefined : json['color'],
        'colorCode': !(0, runtime_1.exists)(json, 'colorCode') ? undefined : json['colorCode'],
        'variationNumber': !(0, runtime_1.exists)(json, 'variationNumber') ? undefined : json['variationNumber'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : (0, ProductImage_1.ProductImageFromJSON)(json['image']),
        'webColors': !(0, runtime_1.exists)(json, 'webColors') ? undefined : json['webColors'],
        'shadeColors': !(0, runtime_1.exists)(json, 'shadeColors') ? undefined : json['shadeColors'],
        'seasons': !(0, runtime_1.exists)(json, 'seasons') ? undefined : json['seasons'],
        'assortmentCampaigns': !(0, runtime_1.exists)(json, 'assortmentCampaigns') ? undefined : json['assortmentCampaigns'],
        'featured': !(0, runtime_1.exists)(json, 'featured') ? undefined : json['featured'],
        'tags': !(0, runtime_1.exists)(json, 'tags') ? undefined : (json['tags'] === null ? null : json['tags'].map(TagType_1.TagTypeFromJSON)),
        'previewImage': !(0, runtime_1.exists)(json, 'previewImage') ? undefined : (0, ProductImage_1.ProductImageFromJSON)(json['previewImage']),
        'skus': !(0, runtime_1.exists)(json, 'skus') ? undefined : (json['skus'] === null ? null : json['skus'].map(ProductSku_1.ProductSkuFromJSON)),
        'images': !(0, runtime_1.exists)(json, 'images') ? undefined : (json['images'] === null ? null : json['images'].map(ShopProductImage_1.ShopProductImageFromJSON)),
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : (0, PriceInformation_1.PriceInformationFromJSON)(json['price']),
    };
}
exports.ProductSkuShopProductImageSkuVariationFromJSONTyped = ProductSkuShopProductImageSkuVariationFromJSONTyped;
function ProductSkuShopProductImageSkuVariationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'color': value.color,
        'colorCode': value.colorCode,
        'variationNumber': value.variationNumber,
        'image': (0, ProductImage_1.ProductImageToJSON)(value.image),
        'webColors': value.webColors,
        'shadeColors': value.shadeColors,
        'seasons': value.seasons,
        'assortmentCampaigns': value.assortmentCampaigns,
        'tags': value.tags === undefined ? undefined : (value.tags === null ? null : value.tags.map(TagType_1.TagTypeToJSON)),
        'previewImage': (0, ProductImage_1.ProductImageToJSON)(value.previewImage),
        'price': (0, PriceInformation_1.PriceInformationToJSON)(value.price),
    };
}
exports.ProductSkuShopProductImageSkuVariationToJSON = ProductSkuShopProductImageSkuVariationToJSON;
